// @flow
import React, { Component } from 'react';
//types
import {
  type PaginatorProps,
  type Currency,
  type Currencies
} from '../../../utilities/types';
import { type TooltipProps } from '..';
import { connect } from 'react-redux';
import {
  loadReferredPartnersIndex,
  changePage,
  setPerPageFilter,
  orderByProcessingVolume,
  orderByTransactionFee,
  orderByNumMerchants
} from './reducer';
import { showTooltip } from '../reducer';

import TableHeader from './TableHeader';
import TableRow from './TableRow';
import CrudTableIndex from '../../../modules/CrudTable/CrudTableIndex';
import TableStatistics from '../TableStatistics';
import { getPartnerCurrency } from '../../../utilities/selectors';
import { history } from '../../../utilities/history';

export type ReferralDetails = {
  company_name: string,
  email: string,
  id: number,
  total_fees_usd: string,
  total_merchants: number,
  total_processing_vol_usd: string
};
type Filters = {
  perPageFilter: string,
  setPerPageFilter: () => void
};
type Props = {
  partnerCurrency: Currency,
  currencies: Currencies,
  referredPartnersIndex: ReferralDetails[],
  loadReferredPartnersIndex: () => void,
  failedLoad: boolean,
  loading: boolean,
  // //Paginator
  ...$Exact<PaginatorProps>,
  // downloadCsv: string => void,
  //TableHeader
  orderByProcessingVolume: () => void,
  orderByTransactionFee: () => void,
  orderByNumMerchants: () => void,
  orderByProcessingVolumeState: number,
  orderByTransactionFeeState: number,
  orderByNumMerchantsState: number,
  ...$Exact<TooltipProps>
} & Filters;

class ReferredPartnersIndex extends Component<Props> {
  handleShow = id => {
    history.push({
      pathname: `/partners/referred/${id}`,
      state: {
        prevPath: '/partners/referred'
      }
    });
  };

  render() {
    return (
      <>
        <TableStatistics />
        <CrudTableIndex
          // Table
          TableHeader={
            <TableHeader
              orderBy={{
                processingVolume: this.props.orderByProcessingVolume,
                transactionFee: this.props.orderByTransactionFee,
                numMerchants: this.props.orderByNumMerchants
              }}
              orderState={{
                processingVolume: this.props.orderByProcessingVolumeState,
                transactionFee: this.props.orderByTransactionFeeState,
                numMerchants: this.props.orderByNumMerchantsState
              }}
              activeTooltip={this.props.activeTooltip}
              showTooltip={this.props.showTooltip}
            />
          }
          tableData={this.props.referredPartnersIndex}
          loadTableIndexData={this.props.loadReferredPartnersIndex}
          loading={this.props.loading}
          failedLoad={this.props.failedLoad}
          // $FlowFixMe props are passed in by cloneElement
          TableRow={<TableRow />}
          tableBodyOptions={{
            text: 'No Partners',
            model: 'Partners',
            img: 'partners',
            partnerCurrency: this.props.partnerCurrency,
            currencies: this.props.currencies,
            handleShow: id => this.handleShow(id)
          }}
          // Paginator
          paginatorTotal={this.props.paginatorTotal}
          currentPage={this.props.currentPage}
          // $FlowFixMe TODO: until paginatorProps is added to CrudTableIndex in commission-payouts PR
          changePage={this.props.changePage}
          previouslyVisited={this.props.previouslyVisited}
          // Paginator Filter
          currentPerPage={this.props.perPageFilter}
          setPerPage={this.props.setPerPageFilter}
          perPageOptions={[10, 25, 50]}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  partnerCurrency: getPartnerCurrency(state),
  currencies: state.global.currencies,
  referredPartnersIndex: state.partners.referredPartners.index.referral_details,
  loading: state.partners.referredPartners.index.loading,
  failedLoad: state.partners.referredPartners.index.failedLoad,
  currentPage: state.partners.referredPartners.index.currentPage,
  paginatorTotal: state.partners.referredPartners.index.paginatorTotal,
  perPageFilter: state.partners.referredPartners.index.perPageFilter,
  previouslyVisited: state.partners.referredPartners.index.previouslyVisited,
  orderByProcessingVolumeState:
    state.partners.referredPartners.index.orderByProcessingVolumeState,
  orderByTransactionFeeState:
    state.partners.referredPartners.index.orderByTransactionFeeState,
  orderByNumMerchantsState:
    state.partners.referredPartners.index.orderByNumMerchantsState,
  activeTooltip: state.partners.index.activeTooltip
});

const mapDispatchToProps = {
  loadReferredPartnersIndex,
  changePage,
  setPerPageFilter,
  orderByProcessingVolume,
  orderByTransactionFee,
  orderByNumMerchants,
  showTooltip
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReferredPartnersIndex);
